import styles from "./FooterBottomBar.module.css";

const FooterBottomBar = ({ copyrightText, setCopyrightText }) => {
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <h3>Footer Bottom Bar</h3>
        <p>Content shown below the footer links</p>
      </div>

      <div className={styles.field}>
        <label>Copyright Text</label>
        <input
          className={styles.input}
          value={copyrightText}
          onChange={(e) => setCopyrightText(e.target.value)}
          placeholder="e.g. © 2026 Sunsky Travel. All rights reserved."
        />
      </div>
    </div>
  );
};

export default FooterBottomBar;
